import { render, staticRenderFns } from "./SaleEditor.vue?vue&type=template&id=56fa0ccd&scoped=true&"
import script from "./SaleEditor.vue?vue&type=script&lang=js&"
export * from "./SaleEditor.vue?vue&type=script&lang=js&"
import style0 from "./SaleEditor.vue?vue&type=style&index=0&id=56fa0ccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa0ccd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fa0ccd')) {
      api.createRecord('56fa0ccd', component.options)
    } else {
      api.reload('56fa0ccd', component.options)
    }
    module.hot.accept("./SaleEditor.vue?vue&type=template&id=56fa0ccd&scoped=true&", function () {
      api.rerender('56fa0ccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sale/SaleEditor.vue"
export default component.exports